import { api } from "shared/config/api/api";
import { TICKETS_LIST_TAG, ticketTag } from "entities/support-ticket";
import type { CloseTicketResponse } from "entities/support-ticket";

export const closeTicketApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Notifications — чтобы в inbox обновился action.can_reply.
    closeTicket: builder.mutation<CloseTicketResponse, number>({
      query: (ticketId) => ({
        url: `/support/tickets/${ticketId}/close`,
        method: "POST",
      }),
      invalidatesTags: (_result, _error, ticketId) => [
        ticketTag(ticketId),
        TICKETS_LIST_TAG,
        "Notifications",
      ],
    }),
  }),
});

export const { useCloseTicketMutation } = closeTicketApi;
